<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14QgDvV/tc-custom/9781646562312.jpg?1723405649374" alt="This image is the cover for the book The Queen's Pain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Queen's Pain
      </h1>
      <p class="bookDescription body article font2">
        <p>Sequel to <i>The Circus Crown</i><br/><br/>Kenna Crossley now runs the town of New Somerset. She is responsible for its food, its electricity, and most importantly, its protection. She will defend it with her life if necessary, in order to keep its citizens -- including her ailing father Dakota -- safe from harm.<br/><br/>But the appearance of a strange, deformed animal puts everything Kenna has worked for at risk. Soon the mountains surrounding their little town are overrun with bloodthirsty creatures. As Kenna fights them and builds up barriers around the town, she begins to suspect it's a losing battle.<br/><br/>Can Kenna protect New Somerset, or will the mutated monsters win? And who among them will survive?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jaimie N. Schock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0507efe4